import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import usersRoute from "@/router/users";
import manajemenSoal from "@/router/bank-soal";
import manajemenKampus from "./manajemen-kampus";
import manajemenEvent from "./manajemen-event";
import manajemenBundle from "./manajemen-bundle";
import manajemenKomunitas from "./manajemen-komunitas";
import accessControl from "@/router/access-control";
import paketTryout from "@/router/manajemen-try-out";
import modul from "@/router/modul";
import dashboard from "@/router/dashboard";
import RiwayatPembayaran from "@/router/invoice";
import video from "@/router/manajemen-video/video";
import live from "@/router/manajemen-video/live";
import voucher from "@/router/voucher";
import developerOptions from "@/router/developer-options";

import repository from "@repofactory";
import ebook from "./manajemen-materi/ebook";
import ringkasanMateri from "./manajemen-materi/ringkasan-materi";
const authRepo = repository.get("auth");
const developerOptionsEnabled =
  process.env.VUE_APP_DEVELOPER_OPTIONS === "true";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    ...dashboard,
    ...usersRoute,
    ...manajemenSoal,
    ...accessControl,
    ...paketTryout,
    ...modul,
    ...manajemenKampus,
    ...manajemenKomunitas,
    ...RiwayatPembayaran,
    ...video,
    ...manajemenEvent,
    ...manajemenBundle,
    ...live,
    ...ebook,
    ...ringkasanMateri,
    ...voucher,
    ...(developerOptionsEnabled ? developerOptions : []),
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/welcome",
      name: "welcome",
      component: () => import("@/views/Welcome.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/goodbye",
      name: "goodbye",
      component: () => import("@/views/Goodbye.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.name === "preview-video-gratis") {
    to.meta.breadcrumb = [
      {
        text: "Video Gratis",
        active: false,
        to: { path: "/video/gratis" },
      },
      {
        text: "List Video Gratis",
        active: false,
        to: { path: `/video-detail/${to.params.id}` },
      },
      {
        text: "Preview Video",
        active: true,
      },
    ];
  }

  if (to.name === "preview-ebook") {
    to.meta.breadcrumb = [
      {
        text: "Ebook",
        active: false,
        to: { path: "/ebook" },
      },
      {
        text: "List Ebook",
        active: false,
        to: { path: `/ebook-detail/${to.params.id}` },
      },
      {
        text: "Preview Ebook",
        active: true,
      },
    ];
  }

  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refresh_token");

  if (to.meta.requireAuth) {
    if (token) {
      if (!store.state.auth.isLogin) {
        try {
          await store.dispatch("auth/user");
        } catch (e) {
          console.error("Token invalid, redirect login");
          localStorage.removeItem("token");
          next({ name: "login" });
          return;
        }
      }
      next();
    } else if (refreshToken) {
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    if (to.name === "login" && store.state.auth.isLogin) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  }
});

// router.bef

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
